module.exports = __webpack_public_path__ + "img/e34c509c8f7bdda24ee25a5b59d89a16.79014af9.jpg";